
// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import config from "../config";
// import { toast } from "react-toastify";

// const AddStyleModal = ({
//   styleModalOpen,
//   handleStyleModalClose,
//   selectedStyle,
//   productsInOrder,
//   customerId,
//   isOrder,
//   products = [], 
//   onMeasurementsUpdated
// }) => {
//   const [styleFields, setStyleFields] = useState([]);
//   const [formData, setFormData] = useState({});
//   const [isSaving, setIsSaving] = useState(false);
//   const [isLoading, setIsLoading] = useState(false);
//   let productId = productsInOrder;

//   const CUSTOM_DEFAULTS = {
//     btnStyle: "2 Button",                 
//     sleeveButton: "4 Button",           
//     backPocket: "2 piped pockets", 
//     shirtCuffStyle: "French Cuff Straight",     
//     lapelwidth: "2.75'",                    
//   };



//   const getStylesFromSuit = (suitProd, componentName) => {
//   if (!suitProd.components || !suitProd.components[componentName]) return null;

//   // The structure: suit.components.jacket.styles (usually a JSON string)
//   let compStyles = suitProd.components[componentName].styles;

//   if (typeof compStyles === 'string' && compStyles !== "") {
//     try { 
//       return JSON.parse(compStyles); 
//     } catch (e) { 
//       console.error("Error parsing suit component styles:", e);
//       return null; 
//     }
//   }

//   return (compStyles && typeof compStyles === 'object') ? compStyles : null;
// };

//   useEffect(() => {
//   if (styleModalOpen) {
//     setIsLoading(true);
//     setFormData({});
//     setStyleFields([]);

//     // 1. Get the Current Product's Saved Styles
//     axios
//       .get(`${config.BASE_URL}/api/v1/getProductStyles/${productId}`)
//       .then((productResponse) => {
//         let productStyles = productResponse.data?.styles || null;
//         let parsedStyles = {};

//         if (typeof productStyles === 'string' && productStyles) {
//           try { parsedStyles = JSON.parse(productStyles); } catch (e) { parsedStyles = {}; }
//         } else if (typeof productStyles === 'object' && productStyles !== null) {
//           parsedStyles = productStyles;
//         }

//         // 2. Get the Form Fields definition
//         axios
//           .get(`${config.BASE_URL}/api/v1/styleList?selectedStyle=${selectedStyle}`)
//           .then((styleListResponse) => {
//             const styles = styleListResponse.data[0]?.fields?.value || [];
//             const initialFormData = {};

//             // Build default values
//             styles.forEach((field) => {
//               let defaultVal = "";
//               if (CUSTOM_DEFAULTS[field.fieldkey]) {
//                 const existsInOptions = field.options && field.options.includes(CUSTOM_DEFAULTS[field.fieldkey]);
//                 defaultVal = (existsInOptions || field.fieldType === "text") 
//                   ? CUSTOM_DEFAULTS[field.fieldkey] 
//                   : (field.defaultValue || field.options?.[0]);
//               } else {
//                 defaultVal = field.defaultValue || field.options?.[0] || "";
//               }
//               initialFormData[field.fieldkey] = defaultVal;
//             });


// let finalData = { ...initialFormData };
// const hasExistingData = parsedStyles && Object.keys(parsedStyles).length > 0;

// if (hasExistingData) {
//     // Agar current product ka apna data hai, toh wahi use karein
//     finalData = { ...finalData, ...parsedStyles };
// } else {
//     const targetName = (selectedStyle || "").toLowerCase().trim();

//     // 1. ID extract karne ka helper (Safe comparison ke liye)
//     const extractId = (id) => (id && typeof id === 'object' ? id._id || id.id : id);
//     const currentCustId = String(extractId(customerId));

//     const getStylesFromProduct = (p) => {
//         let s = p.styles;
//         if (!s) return null;
//         try {
//             return typeof s === 'string' ? JSON.parse(s) : s;
//         } catch (e) { return null; }
//     };

//     // --- MAIN SEARCH: Style Match + SAME CUSTOMER Match ---
//     const sameStyleProduct = products.find(p => {
//         const pName = (p.description || p.style_name || "").toLowerCase().trim();
//         const pCustId = String(extractId(p.customer_id));
//         const isSelf = String(p._id || p.id) === String(productId);
//         const pStyles = getStylesFromProduct(p);

//         // Shirt agar dusre customer ki hai toh 'pCustId === currentCustId' false ho jayega
//         return pName === targetName && 
//                !isSelf && 
//                pStyles && 
//                pCustId === currentCustId; 
//     });

//     let sourceStyles = null;
//     let sourceName = "";

//     if (sameStyleProduct) {
//         sourceStyles = getStylesFromProduct(sameStyleProduct);
//         sourceName = sameStyleProduct.description;
//     } 
//     // Suit se copy karne ke liye bhi Customer ID check karein
//     else if (targetName === 'jacket' || targetName === 'pant') {
//         const suitProduct = products.find(p => {
//             const pName = (p.description || "").toLowerCase();
//             const pCustId = String(extractId(p.customer_id));
//             return pName.includes('suit') && pCustId === currentCustId;
//         });

//         if (suitProduct) {
//             const compStyles = getStylesFromSuit(suitProduct, targetName);
//             if (compStyles) {
//                 sourceStyles = compStyles;
//                 sourceName = `Suit (${targetName})`;
//             }
//         }
//     }

//     // Apply styles only if found for the SAME customer
//     if (sourceStyles) {
//         console.log(`✅ Prefilling ${selectedStyle} from ${sourceName} for Customer ${currentCustId}`);
//         styles.forEach(field => {
//             const key = field.fieldkey;
//             if (sourceStyles[key]) {
//                 finalData[key] = sourceStyles[key];
//             }
//         });
//     } else {

//     }
// }
// // --- PREFILL LOGIC ENDS ---

//             // Handle Double Breasted UI
//             let updatedFields = [...styles];
//             if (finalData.jacket_style === "Double Breasted") {
//               updatedFields = styles.map(f => f.fieldkey === "btnStyle" ? {
//                 ...f, options: ["4 BUTTON 1 FASTNER", "4 BUTTON 2 FASTNER", "6 BUTTON 1 FASTNER", "6 BUTTON 2 FASTNER"]
//               } : f);
//             }

//             setFormData(finalData);
//             setStyleFields(updatedFields);
//             setIsLoading(false);
//           });
//       })
//       .catch((err) => {
//         console.error("Error:", err);
//         setIsLoading(false);
//       });
//   }
// // Dependency array updated: customerId add karna bahut zaroori hai!
// }, [styleModalOpen, selectedStyle, productId, products, customerId]);

//   const handleProductChange = (key, value) => {
//     setFormData((prev) => {
//       const next = { ...prev, [key]: value };

//       // If jacket_style changed, update btnStyle field options
//       if (key === "jacket_style") {
//         const updatedFields = styleFields.map((field) => {
//           if (field.fieldkey === "btnStyle") {
//             const newOptions =
//               value === "Double Breasted"
//                 ? [
//                     "4 BUTTON 1 FASTNER",
//                     "4 BUTTON 2 FASTNER",
//                     "6 BUTTON 1 FASTNER",
//                     "6 BUTTON 2 FASTNER",
//                   ]
//                 : ["1 Button", "2 Button", "3 Button", "4 Button"];

//             // Check if current btnStyle is in the new list. If not, set default.
//             if (!newOptions.includes(next.btnStyle)) {
//               next.btnStyle = newOptions[0];
//             }
//             return { ...field, options: newOptions };
//           }
//           return field;
//         });

//         setStyleFields(updatedFields);
//       }

//       return next;
//     });
//   };

//   const handleSaveProduct = () => {
//     setIsSaving(true);
//     axios
//       .put(`${config.BASE_URL}/api/v1/updateProductStyles/${productId}`, {
//         styles: JSON.stringify(formData),
//       })
//       .then((response) => {
//         toast.success("Product style saved successfully!");

//         setTimeout(() => {
//           handleStyleModalClose();
//             if (onMeasurementsUpdated) {
//             onMeasurementsUpdated(); 
//         }
//           setFormData({});
//         }, 500);

//       })
//       .catch((error) => {
//         console.error("Error saving style data:", error);
//         toast.error("Error saving style data");
//       })
//       .finally(() => {
//         setIsSaving(false);
//       });
//   };

//   if (!styleModalOpen) return null;



//   return (
//     <div className="modal-overlay medium_width_popup">
//       <div className="modal-content">
//         <div className="popup_header">
//           <h4>Add Style ({selectedStyle})</h4>
//           <button type="button" onClick={handleStyleModalClose}>×</button>
//         </div>

//         {isLoading ? (
//              <div style={{ padding: '20px', textAlign: 'center' }}>Loading Styles...</div>
//         ) : (
//             <form>
//             {styleFields.map((field) => (
//                 <div className="form-group row" key={field.fieldkey}>
//                 <label className="field_label">{field.label}</label>
//                 <div className="field_value">
//                     {field.fieldType === "select" && (
//                     <select
//                         id={field.fieldkey}
//                         onChange={(e) => handleProductChange(field.fieldkey, e.target.value)}
//                         value={formData[field.fieldkey] ?? ""}
//                     >
//                         {field.options?.map((option, index) => (
//                         <option key={index} value={option}>
//                             {option}
//                         </option>
//                         ))}
//                     </select>
//                     )}
//                     {field.fieldType === "text" && (
//                     <input
//                         type="text"
//                         id={field.fieldkey}
//                         value={formData[field.fieldkey] ?? ""}
//                         onChange={(e) => handleProductChange(field.fieldkey, e.target.value)}
//                     />
//                     )}
//                 </div>
//                 </div>
//             ))}
//             <div className="form-actions right_align">
//                 <button
//                 type="button"
//                 onClick={handleSaveProduct}
//                 className="btn-primary btn"
//                 disabled={isSaving}
//                 >
//                 {isSaving ? "Saving..." : "Save"}
//                 </button>
//             </div>
//             </form>
//         )}
//       </div>
//     </div>
//   );
// };

// export default AddStyleModal;

import React, { useState, useEffect } from "react";
import axios from "axios";
import config from "../config";
import { toast } from "react-toastify";

const AddStyleModal = ({
  styleModalOpen,
  handleStyleModalClose,
  selectedStyle,
  productsInOrder,
  onMeasurementsUpdated
}) => {
  const [styleFields, setStyleFields] = useState([]);
  const [formData, setFormData] = useState({});
  const [isSaving, setIsSaving] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  // console.log(styleFields,"styleFields")
  // console.log(selectedStyle,"selectedStyle")

  let productId = productsInOrder;

  // Added your requested defaults here
  const CUSTOM_DEFAULTS = {
    btnStyle: "2 Button",
    sleeveButton: "4 Button",
    backPocket: "2 piped pockets",
    shirtCuffStyle: "French Cuff Straight",
    lapelwidth: "2.75'",
  };

  const VEST_DB_BUTTON_OPTIONS = [
    "V Neck DB 6 Button",
    "V Neck DB 4 Buttons",
    "V Neck DB 8 Buttons",
    "V Neck Asymmetric 3 Button",
  ];

  const VEST_NORMAL_BUTTON_OPTIONS = [
    "V Neck 3 Button",
    "V Neck 4 Button",
    "V neck 5 Button",
    "V neck 6 Button",
    "Scooped V as IG 4 Button",
    "Scoop Neck 3 Button",

  ]

  const OVERCOAT_SB_BUTTON_OPTIONS = ["2 Button", "3 Button", "4 Button"];
  const OVERCOAT_DB_BUTTON_OPTIONS = [
    "4 BUTTON 1 FASTNER",
    "4 BUTTON 2 FASTNER",
    "6 BUTTON 1 FASTNER",
    "6 BUTTON 2 FASTNER"
  ];

  useEffect(() => {
    if (styleModalOpen) {
      setIsLoading(true);
      setFormData({});
      setStyleFields([]);

      // 1. Get the Current Product's Saved Styles (Only for THIS specific item)
      axios
        .get(`${config.BASE_URL}/api/v1/getProductStyles/${productId}`)
        .then((productResponse) => {
          let productStyles = productResponse.data?.styles || null;
          let parsedStyles = {};

          if (typeof productStyles === 'string' && productStyles) {
            try { parsedStyles = JSON.parse(productStyles); } catch (e) { parsedStyles = {}; }
          } else if (typeof productStyles === 'object' && productStyles !== null) {
            parsedStyles = productStyles;
          }

          // 2. Get the Form Fields definition from API
          axios
            .get(`${config.BASE_URL}/api/v1/styleList?selectedStyle=${selectedStyle}`)
            .then((styleListResponse) => {
              const styles = styleListResponse.data[0]?.fields?.value || [];
              const initialFormData = {};

              // 3. Build default values using CUSTOM_DEFAULTS
              styles.forEach((field) => {
                let defaultVal = "";

                if (selectedStyle === "Tuxedo") {
                  if (field.fieldkey === "btnStyle") {
                    defaultVal = "1 Button";

                  } else if (field.fieldkey == "lapelBoutonniere") {
                    console.log(field.fieldkey, "fhwfiweufo")
                    defaultVal = "None";
                  } else {
                    // Fallback to CUSTOM_DEFAULTS for other tuxedo fields
                    defaultVal = CUSTOM_DEFAULTS[field.fieldkey] || field.defaultValue || field.options?.[0] || "";
                  }
                }

                else if (CUSTOM_DEFAULTS[field.fieldkey]) {
                  const existsInOptions = field.options && field.options.includes(CUSTOM_DEFAULTS[field.fieldkey]);
                  defaultVal = (existsInOptions || field.fieldType === "text")
                    ? CUSTOM_DEFAULTS[field.fieldkey]
                    : (field.defaultValue || field.options?.[0]);
                } else {
                  defaultVal = field.defaultValue || field.options?.[0] || "";
                }
                initialFormData[field.fieldkey] = defaultVal;
              });

              // 4. Merge only with THIS product's existing data
              // We removed the "Search other products/customers" logic here.
              let finalData = { ...initialFormData, ...parsedStyles };

              // Handle Double Breasted UI logic
              // let updatedFields = [...styles];
              // if (finalData.jacket_style === "Double Breasted") {
              //   updatedFields = styles.map(f => f.fieldkey === "btnStyle" ? {
              //     ...f, options: ["4 BUTTON 1 FASTNER", "4 BUTTON 2 FASTNER", "6 BUTTON 1 FASTNER", "6 BUTTON 2 FASTNER"]
              //   } : f);
              // }

              //               let updatedFields = styles.map((field) => {
              //   if (field.fieldkey !== "btnStyle" && field.fieldkey !== "btnStyleMultiple") return field;
              // console.log(finalData,"finalData")
              // console.log(selectedStyle,"selectedStyle")
              //   const isOvercoat = selectedStyle === "Overcoat";
              //   const coatStyle = finalData.coatStyle || "Single Breasted"; 

              //   // 1. Overcoat Logic
              //   if (isOvercoat) {
              //     return {
              //       ...field,
              //       options: coatStyle === "Double Breasted" ? OVERCOAT_DB_BUTTON_OPTIONS : OVERCOAT_SB_BUTTON_OPTIONS,
              //     };
              //   }

              //   // 🧥 Jacket Double Breasted
              //   if (finalData.jacket_style === "Double Breasted") {
              //     return {
              //       ...field,
              //       options: [
              //         "4 BUTTON 1 FASTNER",
              //         "4 BUTTON 2 FASTNER",
              //         "6 BUTTON 1 FASTNER",
              //         "6 BUTTON 2 FASTNER",
              //       ],
              //     };
              //   }

              //   // 🦺 Vest Double Breasted (even if NOT in DB)
              //   if (finalData.VestStyle === "Double Breasted") {
              //     return {
              //       ...field,
              //       options: VEST_DB_BUTTON_OPTIONS,
              //     };
              //   }

              //   return field;
              // });


              // const targetKey = selectedStyle === "Overcoat" ? "btnStyleMultiple" : "btnStyle";
              // const btnField = updatedFields.find(f => f.fieldkey === targetKey);

              // if (btnField && btnField.options) {
              //   const currentVal = finalData[targetKey];
              //   // If no value exists or the existing value isn't in the allowed list
              //   if (!currentVal || !btnField.options.includes(currentVal)) {
              //     finalData[targetKey] = btnField.options[0];
              //   }
              // }

              //               setFormData(finalData);
              //               setStyleFields(updatedFields);

              let updatedFields = styles.map((field) => {
                // Check both possible button keys
                if (field.fieldkey !== "btnStyle" && field.fieldkey !== "btnStyleMultiple") return field;

                const isOvercoat = selectedStyle === "Overcoat";
                const isVest = selectedStyle === "Vest";
                // Check the actual style selected (default to Single Breasted if empty)
                const coatStyle = finalData.coatStyle || "Single Breasted";
                const jacketStyle = finalData.jacket_style || "Single Breasted";
                const vestStyle = finalData.VestStyle || "Single Breasted";

                if (isOvercoat) {
                  // Force Overcoat to use its specific button list
                  return {
                    ...field,
                    options: coatStyle === "Double Breasted"
                      ? OVERCOAT_DB_BUTTON_OPTIONS
                      : OVERCOAT_SB_BUTTON_OPTIONS,
                  };
                }

                if (isVest) {
                  return {
                    ...field,
                    options: vestStyle === "Double Breasted"
                      ? VEST_DB_BUTTON_OPTIONS
                      : VEST_NORMAL_BUTTON_OPTIONS, // Now includes "V Neck 3 Button" on first load
                  };
                }

                if (jacketStyle === "Double Breasted") {
                  return {
                    ...field,
                    options: ["4 BUTTON 1 FASTNER", "4 BUTTON 2 FASTNER", "6 BUTTON 1 FASTNER", "6 BUTTON 2 FASTNER"]
                  };
                }

                return field;
              });

              // 🔥 FIX: Prevent the "Extra Field" by syncing the formData value
              const activeBtnKey = selectedStyle === "Overcoat" ? "btnStyleMultiple" : "btnStyle";
              const activeField = updatedFields.find(f => f.fieldkey === activeBtnKey);

              if (activeField) {
                // If the currently saved value is NOT in the new filtered options (e.g. it's empty or DB value)
                if (!activeField.options.includes(finalData[activeBtnKey])) {
                  // Force it to the correct Single Breasted default (e.g. "2 Button")
                  finalData[activeBtnKey] = activeField.options[0];
                }
              }

              setFormData(finalData);
              setStyleFields(updatedFields);

              setIsLoading(false);
            });
        })
        .catch((err) => {
          console.error("Error:", err);
          setIsLoading(false);
        });
    }
  }, [styleModalOpen, selectedStyle, productId]); // Removed 'products' and 'customerId' as they are no longer needed for copying

  // const handleProductChange = (key, value) => {
  //   setFormData((prev) => {
  //     const next = { ...prev, [key]: value };
  //     if (key === "jacket_style") {
  //       const updatedFields = styleFields.map((field) => {
  //         if (field.fieldkey === "btnStyle") {
  //           const newOptions = value === "Double Breasted"
  //               ? ["4 BUTTON 1 FASTNER", "4 BUTTON 2 FASTNER", "6 BUTTON 1 FASTNER", "6 BUTTON 2 FASTNER"]
  //               : ["1 Button", "2 Button", "3 Button", "4 Button"];

  //           if (!newOptions.includes(next.btnStyle)) {
  //             next.btnStyle = newOptions[0];
  //           }
  //           return { ...field, options: newOptions };
  //         }
  //         return field;
  //       });
  //       setStyleFields(updatedFields);
  //     }
  //     return next;
  //   });
  // };

  const handleProductChange = (key, value) => {
    setFormData((prev) => {
      const next = { ...prev, [key]: value };

      // ✅ Jacket Double Breasted Logic (existing)
      if (key === "jacket_style") {
        const updatedFields = styleFields.map((field) => {
          if (field.fieldkey === "btnStyle") {
            const newOptions =
              value === "Double Breasted"
                ? [
                  "4 BUTTON 1 FASTNER",
                  "4 BUTTON 2 FASTNER",
                  "6 BUTTON 1 FASTNER",
                  "6 BUTTON 2 FASTNER",
                ]
                : ["1 Button", "2 Button", "3 Button", "4 Button"];

            if (!newOptions.includes(next.btnStyle)) {
              next.btnStyle = newOptions[0];
            }

            return { ...field, options: newOptions };
          }
          return field;
        });

        setStyleFields(updatedFields);
      }


      // ✅ Overcoat Logic: Triggered by "coatStyle" change
      if (selectedStyle === "Overcoat" && key === "coatStyle") {
        const updatedFields = styleFields.map((field) => {
          // Use the key that actually appears in your UI (likely btnStyleMultiple for Overcoats)
          if (field.fieldkey === "btnStyleMultiple" || field.fieldkey === "btnStyle") {
            const newOptions = value === "Double Breasted"
              ? OVERCOAT_DB_BUTTON_OPTIONS
              : OVERCOAT_SB_BUTTON_OPTIONS;

            if (!newOptions.includes(next[field.fieldkey])) {
              next[field.fieldkey] = newOptions[0];
            }
            return { ...field, options: newOptions };
          }
          return field;
        });
        setStyleFields(updatedFields);
      }


      // ✅ Vest Double Breasted Logic (NEW)
      if (key === "VestStyle") {
        const updatedFields = styleFields.map((field) => {
          if (field.fieldkey === "btnStyle") {
            const newOptions =
              value === "Double Breasted"
                ? VEST_DB_BUTTON_OPTIONS
                : VEST_NORMAL_BUTTON_OPTIONS;


            // Reset invalid value
            if (!newOptions.includes(next.btnStyle)) {
              next.btnStyle = newOptions[0];
            }

            return { ...field, options: newOptions };
          }
          return field;
        });

        setStyleFields(updatedFields);
      }

      return next;
    });
  };

  const handleSaveProduct = () => {
    setIsSaving(true);
    axios
      .put(`${config.BASE_URL}/api/v1/updateProductStyles/${productId}`, {
        styles: JSON.stringify(formData),
      })
      .then(() => {
        toast.success("Product style saved successfully!");
        setTimeout(() => {
          handleStyleModalClose();
          if (onMeasurementsUpdated) onMeasurementsUpdated();
          setFormData({});
        }, 500);
      })
      .catch((error) => {
        console.error("Error saving style data:", error);
        toast.error("Error saving style data");
      })
      .finally(() => setIsSaving(false));
  };

  if (!styleModalOpen) return null;

  return (
    <div className="modal-overlay medium_width_popup">
      <div className="modal-content">
        <div className="popup_header">
          <h4>Add Style ({selectedStyle})</h4>
          <button type="button" onClick={handleStyleModalClose}>×</button>
        </div>

        {isLoading ? (
          <div style={{ padding: '20px', textAlign: 'center' }}>Loading Styles...</div>
        ) : (
          <form>
            {styleFields.map((field) => (
              <div className="form-group row" key={field.fieldkey}>
                <label className="field_label">{field.label}</label>
                <div className="field_value">
                  {field.fieldType === "select" && (
                    <select
                      id={field.fieldkey}
                      onChange={(e) => handleProductChange(field.fieldkey, e.target.value)}
                      value={formData[field.fieldkey] ?? ""}
                    >
                      {field.options?.map((option, index) => (
                        <option key={index} value={option}>{option}</option>
                      ))}
                    </select>
                  )}
                  {field.fieldType === "text" && (
                    <input
                      type="text"
                      id={field.fieldkey}
                      value={formData[field.fieldkey] ?? ""}
                      onChange={(e) => handleProductChange(field.fieldkey, e.target.value)}
                    />
                  )}
                </div>
              </div>
            ))}
            <div className="form-actions right_align">
              <button
                type="button"
                onClick={handleSaveProduct}
                className="btn-primary btn"
                disabled={isSaving}
              >
                {isSaving ? "Saving..." : "Save"}
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
};

export default AddStyleModal;